import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  controls: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  // Named for what it does, not for whichever control used it first: both the period and the
  // sort Select carry it, and a third filter here is a natural next step.
  filterSelect: {
    minWidth: 200
  },
  // The window echo. Not styled as an error or a warning — it states a fact about the
  // figures below, and dressing it as an alert would make a normal reading look like a
  // problem.
  tableScope: {
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(1)
  },
  windowNote: {
    color: theme.palette.text.secondary
  },
  paginationContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: theme.spacing(3)
  },
  // Announced, not shown. The window and the row count are already on screen; this exists so
  // a CHANGE to them is heard, which rendering alone does not achieve.
  announcement: {
    position: 'absolute',
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    overflow: 'hidden',
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    whiteSpace: 'nowrap',
    border: 0
  },
  error: {
    marginBottom: theme.spacing(2)
  }
}))

export default useStyles
